// Builds/parses the simple "hourly"/"daily" presets into the cron expression
// stored in Job.schedule (consumed by RunScheduledJobs on the backend).

export function buildCronExpression(frequency, time) {
  if (frequency === 'hourly') {
    return '0 * * * *';
  }

  if (frequency === 'daily') {
    const [hour, minute] = (time || '00:00').split(':');
    return `${parseInt(minute, 10) || 0} ${parseInt(hour, 10) || 0} * * *`;
  }

  return '';
}

// Returns { frequency, time } for a cron string, or frequency: 'custom' if it
// doesn't match one of the presets above (e.g. hand-authored cron expressions).
export function parseCronExpression(cron) {
  if (!cron) {
    return { frequency: 'none', time: '00:00' };
  }

  const parts = cron.trim().split(/\s+/);
  if (parts.length !== 5) {
    return { frequency: 'custom', time: '00:00' };
  }

  const [minute, hour, dom, month, dow] = parts;

  if (minute === '0' && hour === '*' && dom === '*' && month === '*' && dow === '*') {
    return { frequency: 'hourly', time: '00:00' };
  }

  if (/^\d+$/.test(minute) && /^\d+$/.test(hour) && dom === '*' && month === '*' && dow === '*') {
    const time = `${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`;
    return { frequency: 'daily', time };
  }

  return { frequency: 'custom', time: '00:00' };
}
